export default "__VITE_ASSET__D11TUXmi__"